import api, { authHeader } from "../config/api";

export const loggerServices = {
  saveLog: (data) => api.post(`/api/v1/log`, data, { headers: authHeader() })
};
